// global css
import './_app.page.css';
import 'normalize.css';
import '@apoloenergia/metronic/assets/sass/style.css';
import '@mdi/font/css/materialdesignicons.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import dateLocalePtBR from 'date-fns/locale/pt-BR';

// global js
import 'regenerator-runtime/runtime';

import type { AppProps } from 'next/app';
import Head from 'next/head';
import { Metronic } from './metronic';
import { AppContext } from './_app.context';
import { AppLayout } from './_app.layout';
import { registerLocale } from 'react-datepicker';
import { useEffect } from 'react';

function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    registerLocale('pt-BR', dateLocalePtBR);
  }, []);

  return (
    <AppContext>
      <Head>
        <title>MEGA</title>
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="description" content="MEGA" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="mask-icon" href="/favicon/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Head>
      <Metronic>
        <AppLayout>
          <Component {...pageProps} />
        </AppLayout>
      </Metronic>
    </AppContext>
  );
}

export default App;
